// extracted by mini-css-extract-plugin
export var container = "_pu-0";
export var dotAnimation = "_pu-2";
export var dotsLoading = "_pu-1";